export default __webpack_public_path__ + "static/media/warning--sand--g1.93715f38.png";